import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CvsLogo } from "../../static/assets/icons/CvsLogo";
import { ICONS } from "../../static/assets/icons/icons";
import { HamburgerIcon } from "../hamburgerIcon/HamburgerIcon";
import { MenuItem } from "./MenuItem";
import styles from "./style.module.css";

export const Navbar = ({ menuItems, pageTop, sectionRefs }) => {
  const [expanded, setExpanded] = useState(false);

  const scrollToTop = (event) => {
    setExpanded(false);
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.brandIconsContainer}>
        <Link className={styles.flexWrapper} to="/" onClick={scrollToTop}>
          <CvsLogo className={styles.cvsLogo} />
        </Link>
        <img
          src={ICONS.NAVBAR_ICON}
          alt="navbar-icon"
          className={styles.navbarIcon}
        />
      </div>
      <div onClick={() => setExpanded(!expanded)} className={styles.menuIcon}>
        <HamburgerIcon expanded={expanded} />
      </div>
      <ul className={`${styles.navMenu} ${expanded ? styles.expanded : ""}`}>
        {menuItems.map((item, i) => (
          <MenuItem
            pageTop={pageTop}
            sectionRefs={sectionRefs}
            setExpanded={setExpanded}
            item={item}
            key={`menuitem_${i}`}
          />
        ))}
      </ul>
    </nav>
  );
};
